export default __webpack_public_path__ + "static/media/logout-icon.a6eede60.svg";